<template>
  <v-navigation-drawer
    v-model="showInfoDrawer"
    fixed
    hide-overlay
    class="elevation-2 info-drawer"
    width="400"
    right
  >
    <template v-slot:prepend>
      <v-list-item two-line>
        <v-list-item-content>
          <v-toolbar flat dense>
            <v-toolbar-title
              ><h2 class="text-h6">{{ title }}</h2></v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn
              title="Lukk infovindu"
              aria-label="Lukk infovindu"
              small
              color="primary"
              @click="showInfoDrawer = false"
              icon
            >
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </v-toolbar>

          <v-tabs
            style="min-width: 350px; max-width: 350px; max-height: 36px;"
            :show-arrows="false"
            height="40"
            class="pt-0 mt-0 pl-0 ml-0"
            v-model="activeInfoDrawerTab"
          >
            <v-tab @keyup.space="activeInfoDrawerTab = 0">Tidsserie</v-tab>
            <v-tab @keyup.space="activeInfoDrawerTab = 1">Feltegenskaper</v-tab>
            <v-spacer />
          </v-tabs>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-divider></v-divider>
    <map-popup-table
      class="pa-4 pb-14"
      v-if="clickedTimeSeries.length > 0"
      :tidsserie="clickedTimeSeries[0].attributes"
    />
    <v-footer absolute class="elevation-2 pb-3">
      <v-tooltip :open-delay="1000" top>
        <template v-slot:activator="{ on }">
          <v-btn
            depressed
            block
            v-on="on"
            color="primary"
            dark
            @click="showExportDialog = true"
            >Eksporter denne tidsserien</v-btn
          >
        </template>
        <span>Eksporter metadata eller døgnverdier for denne tidsserien</span>
      </v-tooltip>
    </v-footer>
    <export-data
      :title="'Eksporterer tidsserie: ' + title"
      :show="showExportDialog"
      :singleTimeserie="
        clickedTimeSeries.length > 0 ? clickedTimeSeries[0].attributes : null
      "
      @dialog-closed="showExportDialog = false"
    />
  </v-navigation-drawer>
</template>

<script>
import ExportData from "../Table/ExportData.vue";
import { mapState } from "vuex";
import { MapPopupTable } from "@/components";

export default {
  name: "InfoDrawer",
  components: {
    MapPopupTable,
    ExportData,
  },
  data: () => {
    return {
      showExportDialog: false,
    };
  },
  computed: {
    ...mapState(["queryExpression", "currentMapExtent", "clickedTimeSeries"]),
    activeInfoDrawerTab: {
      get() {
        return this.$store.state.activeInfoDrawerTab;
      },
      set(newValue) {
        return this.$store.dispatch("setActiveInfoDrawerTab", newValue);
      },
    },
    title: function() {
      if (this.clickedTimeSeries.length > 0) {
        let timeSerie = this.clickedTimeSeries[0];
        if (
          Object.prototype.hasOwnProperty.call(
            timeSerie.attributes,
            "objektType"
          )
        ) {
          return (
            timeSerie.attributes.stasjonNavn +
            " (" +
            timeSerie.attributes.stasjonNr +
            ")"
          );
        } else {
          return (
            timeSerie.attributes.STASJONSNAVN +
            " (" +
            timeSerie.attributes.STASJONID +
            ")"
          );
        }
      } else {
        return "Uten tittel";
      }
    },
    showInfoDrawer: {
      get() {
        return this.$store.state.showInfoDrawer;
      },
      set(newValue) {
        return this.$store.dispatch("setShowInfoDrawer", newValue);
      },
    },
  },
};
</script>

<style>
.info-drawer {
  padding-top: 100px;
  padding-bottom: 4px;
}
</style>
